import { createTheme } from "@mui/material/styles";

export const useTableStyles = () =>
  createTheme({
    components: {
      
      MuiListItem: {
        styleOverrides: {
          root: {
            fontSize: "0.813rem",
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      },

      MuiButton: {
        styleOverrides: {
          root: {
            //backgroundColor: "#3c5a77",
            //borderRadius: " 0.95rem",
           // border: 0,
            color:"#808080",
            //color: "white !important",
            fontFamily: "Poppins",
            // height: 38,
            textTransform: "none",
            fontWeight: "bold",
            fontSize: "0.85rem",
            textAlign: "center",
          },
          text: {
            //backgroundColor: "#3c5a77",
            color: "white",
            fontWeight: "lighter",
            fontSize: "0.95rem",
            textAlign: "center",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            //backgroundColor: "#3c5a77 !important",
            fontSize: "10px",
            textTransform: "capitalize",
            color: "#000",
            fontFamily: "Poppins",            
          },
          body: {
            fontSize: "0.9rem",
            color: "#000000",
            fontWeight: "bold",
            fontFamily: "Poppins",            
            paddingLeft:"33px"
          },
          root: { fontFamily: "Poppins" },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor: "#3c5a77",
            color: "yellow",
            height: "40px",
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: { fontFamily: "Poppins" },
          
        },
      },

      MuiToolbar: {
        styleOverrides: {
          root: {
            backgroundColor: "#3c5a77",
            color: "#fff",
            display: "flex",
            justifyContent: "flex-end",
          },
        },
      },

      MuiIconButton: {
        styleOverrides: {
          root: {
            color: "white",
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            color: "white",
          },
        },
      },

       MuiSvgIcon: {
        styleOverrides: {
          root: {
           color: "#fff !important",
           },
         },
      },
    },
  });
